import { render, staticRenderFns } from "./AddFence.vue?vue&type=template&id=bb98781c&scoped=true&"
import script from "./AddFence.vue?vue&type=script&lang=js&"
export * from "./AddFence.vue?vue&type=script&lang=js&"
import style0 from "./AddFence.vue?vue&type=style&index=0&id=bb98781c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb98781c",
  null
  
)

export default component.exports